/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag } from "../unleash";

const FlagsOtpRox = {
  otp_adjust_manual_saldo: new Rox.Flag(false),
  otp_enable_change_password: new Rox.Flag(false),
  otp_enable_wd_saldo: new Rox.Flag(false),
  otp_enable_wd_cod: new Rox.Flag(false)
};

const FlagsOtpFcs = {
  permission_change_email_otp_enable: new FcsFlag.Flag(false)
};

export const FlagsOtp = {
  ...FlagsOtpRox,
  ...FlagsOtpFcs
};

export function initFlagsOtp() {
  Rox.register("otp", FlagsOtpRox);
  FcsFlag.register("feature2FA", FlagsOtpFcs);
}
